import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import {
  createParticipationStatus,
  deleteParticipationStatus,
  updateParticipationStatus,
} from '../../../store/membership/ParticipationStatusReducer'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const ParticipationStatusForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const dispatch = useAppDispatch()
    const { error } = useAppSelector((state) => state.participationStatus)

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          create: Create,
          update: Update,
          delete: Delete,
        }}
        handlers={{
          create: async (values) =>
            dispatch(createParticipationStatus(values)).then(() => {
              return true
            }),
          update: async (values) =>
            dispatch(updateParticipationStatus(values)).then(() => {
              return true
            }),
          delete: async (values) =>
            dispatch(deleteParticipationStatus(values)).then(() => {
              return true
            }),
        }}
      />
    )
  }
)

ParticipationStatusForm.displayName = 'ParticipationStatusForm'

export default ParticipationStatusForm
